<template>
  <div class="folders">
    <div class="heading">
      <div class="w-auto md:w-full"/>
      <div
          class="searchbar"
          v-if="showSearchBar">
        <form-input :placeholder="$t('generic.search')"></form-input>
      </div>
    </div>
    <div class="folder-content">
      <folder-container>
        <folder-element
            :key="element.id"
            :element="element"
            :showEditButtons="showEditButtons"
            v-for="element in elements"
            @select="selectElement(element)"
            @multiSelect="handleMultiSelect"
            :emitClickEvent="layout === 'splitview'"
            :selected="selectedElements.includes(element.id)">
          {{ element.categoryname }}
        </folder-element>
      </folder-container>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import ContentMixin from '../../mixin/content'

export default {
  props: [
    'layout',
    'category',
    'isDigitalSignage',
  ],
  computed: {
    ...mapGetters({
      sortType: 'category/sortType',
      sortDirection: 'category/sortDirection',
      selectedElements: 'category/selectedElements',
      showEditButtons: 'category/showEditButtons',
    }),
    showSearchBar() {
      return this.$helper.findAttributeValue(this.category, 'CMS-Configuration')?.includes('EnableSearch')
    },
  },
  data() {
    return {
      elements: [],
    }
  },
  async created() {
    await this.searchCategories()
  },
  methods: {
    async selectElement(category) {
      const componentType = this.$helper.resolveComponentTypeByCategory(category)
      if (this.layout === 'splitview' && componentType !== 'folder') {
        return this.$emit('selectElement', category)
      }
      this.elements = await this.$api.findCategories(this.$helper.extractIdFromSlug(category.id))
      this.$store.commit('category/setElements', this.elements)
    },
    async handleMultiSelect($event) {
      let currentSelectedElements = JSON.parse(JSON.stringify(this.selectedElements))
      if (currentSelectedElements.includes($event)) {
        currentSelectedElements = currentSelectedElements.filter(element => element !== $event)
      } else {
        currentSelectedElements.push($event)
      }
      this.$store.commit('category/setSelectedElements', currentSelectedElements)
    },
    async searchCategories() {
      // let z = this.category?.breadcrumbs[0].id
      // if (this.user.startId) z = this.user.startId
      this.elements = await this.$api.searchCategories(this.$helper.extractIdFromSlug(this.category.quicklink), this.sortType, this.sortDirection, null)
      this.$store.commit('category/setElements', this.elements)
    }
  },
  mixins: [
    ContentMixin,
  ],
  inject: [
    '$api',
    '$helper',
  ],
  emits: [
    'selectElement'
  ]
}
</script>

<style lang="scss" scoped>
.folders {
  @apply
  md:p-6
  md:pt-0
  md:flex
  md:w-full
  md:h-full
  md:flex-col;

  .heading {
    @apply
    flex
    p-2
    gap-2
    md:py-2
    md:px-7
    w-full
    items-center
    justify-between;

    .title {
      @apply
      text-2xl;
    }

    .searchbar {
      @apply
      w-full
      md:w-1/3;
    }
  }

  .folder-content {
    @apply
    flex
    w-full
    h-full
    items-center
    overflow-y-auto;
  }
}
</style>